import { TFunction } from "i18next"
import { Dispatch, SetStateAction } from "react"

export const ConciliableLabel = (
  t: TFunction,
  conciliacionBancariaId: string | null | undefined,
  setShowModalConciliacion: Dispatch<
    SetStateAction<{
      show: boolean
      data: string | null
    }>
  >
) => {
  return (
    <span>
      {typeof conciliacionBancariaId === "string" ? (
        <span
          onClick={() =>
            setShowModalConciliacion({
              show: true,
              data: conciliacionBancariaId,
            })
          }
          className='tw-cursor-pointer tw-text-info-100 tw-no-underline hover:tw-underline'
        >
          {t("bancos.statusConciliacion.conciled")}
        </span>
      ) : (
        <span className='tw-text-text'>
          {t("bancos.statusConciliacion.notConciled")}
        </span>
      )}
    </span>
  )
}
